document.addEventListener('DOMContentLoaded', () => {
	if (window.innerWidth > 640) {
		const works = document.querySelectorAll('.about__item--work')
		const maxHeight = window.innerHeight * 0.35
		works.forEach(work => {

			const list = work.querySelector('.about__item-list')
			if (!list) return
			const items = Array.from(list.children)
			let currentColumn = work
			let currentList = list
			let currentHeight = 0

			items.forEach((item) => {
				currentHeight += item.offsetHeight
				if (currentHeight > maxHeight) {
					const clone = work.cloneNode(true)
					const cloneList = clone.querySelector('.about__item-list')
					cloneList.innerHTML = ''
					work.parentNode.insertBefore(clone, currentColumn.nextSibling)
					currentColumn = clone
					currentList = cloneList
					currentHeight = item.offsetHeight
				}
				currentList.appendChild(item)
			})
		})
	}
	
	const sliders = document.querySelectorAll('.about__horizontal')
	sliders.forEach(slider => {
		let isDown = false
		let startX
		let scrollLeft

		slider.addEventListener('mousedown', (e) => {
			isDown = true
			startX = e.pageX - slider.offsetLeft
			scrollLeft = slider.scrollLeft
		})

		document.addEventListener('mouseup', () => {
			isDown = false
		})

		slider.addEventListener('mousemove', (e) => {
			if (!isDown) return
			e.preventDefault()
			const x = e.pageX - slider.offsetLeft
			const walk = (x - startX) * 1.5
			slider.scrollLeft = scrollLeft - walk
		})

		slider.addEventListener('wheel', (e) => {
			if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
				e.preventDefault()
				slider.scrollLeft += e.deltaY
			}
		}, { passive: false })
	})
})